import { useMemo } from "react";
import { ChatButton } from "./ChatButton";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { useChatUnreadCount } from "@core/features/chat";
import { useChatActions, useTalkJSData } from "@platform/hooks/useChat";
import { useUser } from "@platform/store";
import { useFetchUserCircles } from "@core/features/circle";

export type Props = {
  children?: React.ReactNode;
  className?: string;
  containerClassName?: string;
  badgeClassName?: string;
  isChatDisabled?: boolean;
};

export function ChatButtonContainer({
  children,
  className,
  containerClassName,
  badgeClassName,
  isChatDisabled,
}: Props) {
  const user = useUser();
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;
  const { shouldShowChat, isLoading } = useChatVisibility({
    userCircles,
    isChatDisabled,
  });

  const talkjsData = useTalkJSData();
  const allowedConversationIds = useMemo(
    () =>
      talkjsData?.conversations.map((c) => c.talkjs_conversation_id) ?? [],
    [talkjsData]
  );
  const unreadCount = useChatUnreadCount(allowedConversationIds);
  const { openChat } = useChatActions();

  // Don't render chat button if chat is disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  return (
    <ChatButton
      className={className}
      containerClassName={containerClassName}
      badgeClassName={badgeClassName}
      unreadCount={unreadCount}
      onClick={openChat}
    >
      {children}
    </ChatButton>
  );
}

export default ChatButtonContainer;


